import { css, withBem } from "../../sitches.config";

export const styles = withBem("compound-input", {
  compoundInput: css({
    display: "inline-flex"
  })
});
